import React, { Component } from "react"
import {
  WORLD_COUNTRIES,
  US_STATES,
  CANADA_PROVINCES
} from "../../../constants"
import { isEmpty } from "../../utils"
import { isStateFieldLocked } from "../main/accountUtil"
import { Field, Columns } from '../../elements'

class AddressInputBlock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      address_line_1: this.props.addressData.address_line_1,
      address_line_2: this.props.addressData.address_line_2,
      address_city: this.props.addressData.address_city,
      address_region: this.props.addressData.address_region,
      address_country: this.props.addressData.address_country,
      address_postal_code: this.props.addressData.address_postal_code
    }
  }
  setFieldValue = (field, value) => {
    this.setState(state => {
      state[field] = value
      return state
    })

    this.props.onChange(field, value)
  }

  isDisabled = fieldLevelDisabled => {
    //alert(this.props.hidden.address_country)
    if (this.props.locked) {
      return true
    }

    if (fieldLevelDisabled) {
      return true
    }

    return false
  }

  render() {
    const {
      address_line_1,
      address_line_2,
      address_city,
      address_region,
      address_country,
      address_postal_code
    } = this.state

    const { errors, disabled } = this.props

    return (
      <React.Fragment>
        <div className="block">
          <Field
            label="Country"
            placeholder="Select Country"
            fullwidth
            name="address_country"
            id="address_country"
            type="select"
            value={address_country}
            disabled={this.isDisabled(disabled.address_country)}
            error={errors.address_country}
            onChange={({ e, value }) =>
              this.setFieldValue("address_country", value)
            }
            options={WORLD_COUNTRIES}
          />
        </div>
        <div className="block">
          <Field
            placeholder="e.g. 123 Motorcycle Lane"
            label="Street Address"
            fullwidth
            type="input"
            name="address_line_1"
            id="address_line_1"
            disabled={this.isDisabled(disabled.address_line_1)}
            value={address_line_1}
            error={errors.address_line_1}
            onChange={({ e, value }) =>
              this.setFieldValue("address_line_1", value)
            }
          />
        </div>
        <div className="block">
          <Field
            placeholder="e.g. Apt 1"
            fullwidth
            type="input"
            value={address_line_2}
            disabled={this.isDisabled(disabled.address_line_2)}
            onChange={({ e, value }) =>
              this.setFieldValue("address_line_2", value)
            }
            label="Apt., Suite (Optional)"
            id="address_line_2"
            name="address_line_2"
            error={errors.address_line_2}
          />
        </div>
        <Columns>
          <Columns.Column size={4}>
            <Field
              placeholder="e.g. Chicago"
              fullwidth
              type="input"
              label="City"
              id="address_city"
              name="address_city"
              value={address_city}
              onChange={({ e, value }) =>
                this.setFieldValue("address_city", value)
              }
              disabled={this.isDisabled(disabled.address_city)}
              error={errors.address_postal_code}
            />
          </Columns.Column>

          <Columns.Column size={4}>
            {address_country === "CA" && (
              <Field
                placeholder="e.g. Alberta"
                fullwidth
                type="select"
                label="Province"
                options={CANADA_PROVINCES}
                name="address_region"
                id="address_region"
                error={errors.address_region}
                value={address_region}
                onChange={({ e, value }) =>
                  this.setFieldValue("address_region", value)
                }
                disabled={isStateFieldLocked(
                  this.isDisabled(disabled.address_region),
                  this.state.address_country
                )}
              />
            )}
            {address_country === "US" && (
              <Field
                placeholder="e.g. Illinois"
                fullwidth
                type="select"
                label="State"
                options={US_STATES}
                name="address_region"
                id="address_region"
                error={errors.address_region}
                value={address_region}
                onChange={({ e, value }) =>
                  this.setFieldValue("address_region", value)
                }
                disabled={isStateFieldLocked(
                  this.isDisabled(disabled.address_region),
                  this.state.address_country
                )}
              />
            )}
            {address_country !== "US" && address_country !== "CA" && (
              <Field
                label={
                  isEmpty(this.state.address_country)
                    ? "State"
                    : "State/Region/Province"
                }
                fullwidth
                value={address_region}
                onChange={({ e, value }) =>
                  this.setFieldValue("address_region", value)
                }
                id="address_region"
                name="address_region"
                type="input"
                error={errors.address_region}
                disabled={isStateFieldLocked(
                  this.isDisabled(disabled.address_region),
                  this.state.address_country
                )}
              />
            )}
          </Columns.Column>

          <Columns.Column size={4}>
            <Field
              placeholder="e.g. 55555"
              id="address_postal_code"
              name="address_postal_code"
              label="Postal Code"
              fullwidth
              error={errors.address_postal_code}
              value={address_postal_code}
              onChange={({ e, value }) =>
                this.setFieldValue("address_postal_code", value)
              }
              disabled={this.isDisabled(disabled.address_postal_code)}
            />
          </Columns.Column>
        </Columns>
      </React.Fragment>
    )
  }
}
export default AddressInputBlock

AddressInputBlock.defaultProps = {
  addressData: {
    address_line_1: "",
    address_line_2: "",
    address_city: "",
    address_region: "",
    address_country: "",
    address_postal_code: ""
  },
  onChange: null,
  errors: {
    address_line_1: false,
    address_line_2: false,
    address_city: false,
    address_region: false,
    address_country: false,
    address_postal_code: false
  },
  disabled: {
    address_line_1: false,
    address_line_2: false,
    address_city: false,
    address_region: false,
    address_country: false,
    address_postal_code: false
  },
  locked: false
}
